import { Check } from "lucide-react"
import type { TransferSummaryCheckRowProps } from "../types"

/** Angular `summaryinfo` rows: `<i class="fa fa-check mr-2"></i>` before each update line. */
export function TransferSummaryCheckRow({ children, testId }: TransferSummaryCheckRowProps) {
  return (
    <div className="flex gap-2 text-sm text-slate-700" data-testid={testId}>
      <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#78bf0a]" strokeWidth={2.5} aria-hidden />
      <span className="min-w-0 break-words leading-snug">{children}</span>
    </div>
  )
}
